import React from "react";
import * as Scrivito from "scrivito";
import { useRenderProjectsShowing } from "hooks/useRenderProjectsShowing";
import { TablePagination } from "components";

type TableFooterProps = {
  filteredCount: number;
  pagesCount: number;
  currentPageNo: number;
  itemsPerPage: number;
  handleSetCurrentPage: (page: number) => void;
};

export const TableFooter = Scrivito.connect(
  ({
    filteredCount,
    pagesCount,
    currentPageNo,
    itemsPerPage,
    handleSetCurrentPage,
  }: TableFooterProps) => {
    const renderProjectsShowing = useRenderProjectsShowing();

    return (
      <div className="position-relative d-flex justify-content-center align-items-center text-gray-700">
        <div
          className="position-absolute start-0 text-gray-400 mx-2_5"
          data-testid="PROJECT_LIST_SHOWING"
        >
          {renderProjectsShowing(currentPageNo, filteredCount, itemsPerPage)}
        </div>

        <TablePagination
          pagesCount={pagesCount}
          currentPage={currentPageNo}
          onChangePage={handleSetCurrentPage}
        />
      </div>
    );
  },
);
